import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { LearningDemoQuest } from '@/components/onboarding/LearningDemoQuest'
import { onboardingApi, type LearningDemoOutcome } from '@/api/onboarding'
import { markLearningDemoCompleted } from '@/lib/learningDemoStorage'
import { useAuthStore } from '@/store/authStore'

export function LearningDemoPage() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const userId = useAuthStore((state) => state.user?.id)

  const finish = async (outcome: LearningDemoOutcome) => {
    try {
      await onboardingApi.completeLearningDemo(outcome)
    } catch {
      // local progress still advances — funnel event is best-effort
    }
    if (userId) {
      markLearningDemoCompleted(userId)
      queryClient.setQueryData(['learning-demo-status', userId], { completed: true })
    }
    queryClient.invalidateQueries({ queryKey: ['vocabulary'] })
    queryClient.invalidateQueries({ queryKey: ['vocabularyStats'] })
    queryClient.invalidateQueries({ queryKey: ['dashboard'] })
    // Land in the first recommended article — core loop starts with reading, not Today widgets.
    navigate('/reading/recommended', { replace: true })
  }

  return (
    <LearningDemoQuest
      onComplete={() => void finish('COMPLETED')}
      onSkip={() => void finish('SKIPPED')}
    />
  )
}
